import moment from "moment";

import { queryKeys } from "../queryKeys";
import {
  getOptionsContracts,
  type OptionContractsResponse,
} from "../rest/data";
import useRequest, { type QueryOptions } from "./useRequest";

export const useGetOptionExpirations = ({
  assetSymbol,
  isCrypto,
  options,
}: {
  assetSymbol?: string;
  isCrypto: boolean;
  options?: QueryOptions<OptionContractsResponse>;
}) =>
  useRequest(
    queryKeys.options.expirations(assetSymbol),
    () =>
      getOptionsContracts({
        underlying_symbol: assetSymbol,
        expiration_date_gte: moment().format("YYYY-MM-DD"),
      }),
    {
      ...options,
      enabled: !isCrypto && !!assetSymbol && (options?.enabled ?? true),
    },
  );

export default useGetOptionExpirations;
